import React, { useMemo, useCallback } from 'react';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import useForecastDate from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useForecastDate';
import Snackbar from 'components/DesignSystem/Snackbar';

export default function ForecastDate() {
  const { availableIntervals, selectedDate, setDate } = useForecastDate();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('forecastdate-accordion'), []);
  const setDateAndClose = useCallback((newDate: Date | null) => {
    setDate(newDate);
    closeAccordion();
  }, [setDate, closeAccordion]);

  return (
    <Accordion.Item eventKey="forecastdate" id="forecastdate-accordion">
      <Accordion.Header>Data de previsão</Accordion.Header>
      <Accordion.Body>
        {availableIntervals.length === 0 && (
          <Snackbar>
            Nenhuma data de previsão disponível para os parâmetros selecionados.
          </Snackbar>
        )}
        {availableIntervals.length > 0 && (
          <DatePicker
            inline
            showMonthDropdown
            showYearDropdown
            selected={selectedDate}
            onChange={setDateAndClose}
            includeDateIntervals={availableIntervals}
          />
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
}
